var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosev2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14858_3090)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99956 8.94269L11.7709 12.714C11.8966 12.8355 12.065 12.9027 12.2398 12.9011C12.4146 12.8996 12.5818 12.8295 12.7054 12.7059C12.829 12.5823 12.8992 12.4151 12.9007 12.2403C12.9022 12.0655 12.835 11.8971 12.7136 11.7714L8.94222 8.00002L12.7136 4.22868C12.835 4.10295 12.9022 3.93455 12.9007 3.75975C12.8992 3.58495 12.829 3.41774 12.7054 3.29414C12.5818 3.17053 12.4146 3.10042 12.2398 3.0989C12.065 3.09738 11.8966 3.16458 11.7709 3.28602L7.99956 7.05735L4.22822 3.28602C4.10192 3.16758 3.9345 3.10293 3.76138 3.10574C3.58825 3.10855 3.42302 3.17861 3.30063 3.30108C3.17824 3.42356 3.1083 3.58884 3.10561 3.76197C3.10293 3.93509 3.1677 4.10247 3.28622 4.22868L7.05689 8.00002L3.28556 11.7714C3.22188 11.8328 3.1711 11.9064 3.13616 11.9877C3.10122 12.0691 3.08283 12.1566 3.08206 12.2451C3.08129 12.3336 3.09815 12.4214 3.13168 12.5033C3.1652 12.5853 3.2147 12.6597 3.27729 12.7223C3.33989 12.7849 3.41432 12.8344 3.49625 12.8679C3.57818 12.9014 3.66597 12.9183 3.75449 12.9175C3.84301 12.9167 3.93049 12.8984 4.01183 12.8634C4.09316 12.8285 4.16673 12.7777 4.22822 12.714L7.99956 8.94269Z",
    fill: "#B2B2B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14858_3090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosev2);
export default __webpack_public_path__ + "static/media/closev2.7e5eccc3be6566bc7a16d2b0981a78e1.svg";
export { ForwardRef as ReactComponent };